export const messages = {
  en: {
    housekeepingDispatch: {
      title: 'Housekeeping Dispatch Management',
      queryConditions: 'Query Conditions',
      more: 'More',
      hide: 'Hide',
      serviceName: 'Service Name',
      orderNo: 'Order No',
      applicant: 'Applicant',
      contact: 'Contact',
      appointmentTime: 'Appointment Time',
      status: 'Status',
      operations: 'Operations',
      transferOrder: 'Transfer',
      returnOrder: 'Return',
      complete: 'Complete',
      visit: 'Visit',
      detail: 'Detail',
      staffName: 'Staff Name',
      processingOpinion: 'Processing Opinion',
      visitSuggestion: 'Visit Suggestion',
      submit: 'Submit',
      cancel: 'Cancel'
    }
  },
  zh: {
    housekeepingDispatch: {
      title: '家政服务派单管理',
      queryConditions: '查询条件',
      more: '更多',
      hide: '隐藏',
      serviceName: '服务名称',
      orderNo: '订单编号',
      applicant: '申请人',
      contact: '联系方式',
      appointmentTime: '预约时间',
      status: '状态',
      operations: '操作',
      transferOrder: '转单',
      returnOrder: '退单',
      complete: '办结',
      visit: '回访',
      detail: '详情',
      staffName: '工单师傅',
      processingOpinion: '处理意见',
      visitSuggestion: '回访建议',
      submit: '提交',
      cancel: '取消'
    }
  }
}